import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';
import { AILocal } from './logger.common';
import { LogRow } from './logger.log-row';
import SeverityLevel = AILocal.SeverityLevel;
import { GlobalVariables } from 'app/services/globals';

export class TraceRow extends LogRow {
    constructor(
        private message: string,
        public severity: SeverityLevel,
        componentName: string) {
        super({ ['componentName']: componentName });
    }

    public generateLoggingEntry(): IExtendedTelemetryItem {
        return { name: 'traces', data: { ...this.getStringifiedProperties(), message: this.message, severity: this.severity } };
    }

    public pushToAppInsights(): void {
        setTimeout(() => {
            if (GlobalVariables.enableAriaLogger) {
                oneDSWeb.trackEvent(this.generateLoggingEntry());
            } else {
                appInsights.trackTrace(this.message, this.getStringifiedProperties(), this.severity);
            }
        }, 0);
    }

    public logToConsole(): void {
        switch (this.severity) {
            case SeverityLevel.Warning: {
                // eslint-disable-next-line no-console
                console.warn(this);
                break;
            }
            case SeverityLevel.Error: {
                // eslint-disable-next-line no-console
                console.error(this);
                break;
            }
            default:
                // eslint-disable-next-line no-console
                console.log(this);
        }
    }
}
